import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import santoshImage from '../../../../public/assets/santosh.jpeg';
import siddharthaImage from '../../../../public/assets/sid.jpeg';

const TrustBuilding = () => {
  const testimonials = [
  {
    id: 1,
    name: 'Santosh S.',
    role: 'Co-founder and CEO',
    company: 'Planeo',
    image: santoshImage,
    imageAlt: 'Professional headshot of confident woman with shoulder-length brown hair wearing navy blazer and white blouse in modern office setting',
    content: 'Abhishek is a very talented engineer and is well versed in frontend/backend systems. He was very instrumental in designing and implementing our web app. His communication is top notch and also went way beyond his comfort zone in helping us iron out many issues. I already worked with him twice, and he is going to be our go to resource moving forward as well. I would highly recommend Abhishek to anyone who is seeking help, be it designing, coding or building out webapps. ',
    rating: 5,
    metric: '300% increase in user engagement'
  },
  {
    id: 2,
    name: 'Siddhartha Gupta',
    role: 'CEO',
    company: 'Zeliant Retail Private Limited',
    image: siddharthaImage,
    imageAlt: 'Professional headshot of Asian businessman with short black hair wearing charcoal suit and blue tie with confident smile',
    content: 'Abhishek has truly elevated my experience on Upwork. Their expertise and dedication were instrumental in creating my product catalogue website. From crafting seamless user interfaces to ensuring optimal functionality, Abhishek demonstrated remarkable skill and professionalism throughout the project. Their proactive communication and problem-solving abilities were invaluable, making the collaboration not just productive but enjoyable. I highly recommend Abhishek to anyone seeking top-tier frontend development services on Upwork.',
    rating: 5,
    metric: '$2M funding secured'
  },
 ];


  const certifications = [
  { id: 1, name: 'ISO 27001', icon: 'Shield' },
  { id: 2, name: 'SOC 2 Type II', icon: 'Lock' },
  { id: 3, name: 'AWS Partner', icon: 'Cloud' },
  { id: 4, name: 'Microsoft Partner', icon: 'Award' }];


  const clientLogos = [
  { id: 1, name: 'TechFlow Solutions' },
  { id: 2, name: 'DataSync Inc' },
  { id: 3, name: 'CloudScale' },
  { id: 4, name: 'InnovateCorp' },
  { id: 5, name: 'FutureStack' },
  { id: 6, name: 'DigitalEdge' }];


  return (
    <section className="py-16 md:py-24 lg:py-32 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full text-primary text-xs md:text-sm font-medium font-body mb-4 md:mb-6">
            <Icon name="Award" size={16} />
            <span>Trusted by Industry Leaders</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-headline text-foreground mb-4 md:mb-6">
            Client Success Stories
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground font-body max-w-3xl mx-auto">
            Don't just take our word for it. Hear from the executives who've partnered with us to transform their businesses.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-6 md:gap-8 mb-12 md:mb-16 lg:mb-20">
          {testimonials?.map((testimonial) =>
          <div
            key={testimonial?.id}
            className="bg-card border border-border rounded-xl p-6 md:p-8 hover:shadow-xl transition-all duration-300">

              <div className="flex items-center space-x-1 mb-4 md:mb-6">
                {[...Array(testimonial?.rating)]?.map((_, index) =>
              <Icon key={index} name="Star" size={16} color="var(--color-warning)" className="fill-current" />
              )}
              </div>

              <p className="text-sm md:text-base text-foreground font-body mb-4 md:mb-6 line-clamp-4">
                "{testimonial?.content}"
              </p>

              <div className="flex items-center space-x-3 mb-4 md:mb-6">
                <Image
                src={testimonial?.image}
                alt={testimonial?.imageAlt}
                className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover" />

                <div>
                  <div className="text-sm md:text-base font-semibold font-headline text-foreground">
                    {testimonial?.name}
                  </div>
                  <div className="text-xs md:text-sm text-muted-foreground font-body">
                    {testimonial?.role}
                  </div>
                </div>
              </div>

              <div className="pt-4 md:pt-6 border-t border-border">
                <div className="flex items-center space-x-2">
                  <Icon name="TrendingUp" size={16} color="var(--color-success)" />
                  <span className="text-xs md:text-sm font-medium font-body text-success">
                    {testimonial?.metric}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* <div className="bg-card border border-border rounded-xl p-8 md:p-12 lg:p-16">
          <div className="text-center mb-8 md:mb-12">
            <h3 className="text-2xl md:text-3xl font-bold font-headline text-foreground mb-3 md:mb-4">
              Certifications & Partnerships
            </h3>
            <p className="text-sm md:text-base text-muted-foreground font-body">
              Industry-recognized certifications and strategic technology partnerships
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-12 md:mb-16">
            {certifications?.map((cert) =>
            <div
              key={cert?.id}
              className="flex flex-col items-center justify-center p-4 md:p-6 bg-background rounded-lg hover:shadow-md transition-all duration-300">

                <div className="w-12 h-12 md:w-16 md:h-16 bg-primary/10 rounded-full flex items-center justify-center mb-3 md:mb-4">
                  <Icon name={cert?.icon} size={24} color="var(--color-primary)" />
                </div>
                <span className="text-xs md:text-sm font-medium font-body text-foreground text-center">
                  {cert?.name}
                </span>
              </div>
            )}
          </div>

          <div className="text-center mb-6 md:mb-8">
            <h4 className="text-lg md:text-xl font-semibold font-headline text-foreground mb-2 md:mb-3">
              Trusted by Leading Companies
            </h4>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
            {clientLogos?.map((logo) =>
            <div
              key={logo?.id}
              className="flex items-center justify-center p-4 md:p-6 bg-background rounded-lg hover:shadow-md transition-all duration-300">

                <span className="text-xs md:text-sm font-medium font-body text-muted-foreground text-center">
                  {logo?.name}
                </span>
              </div>
            )}
          </div>
        </div> */}
      </div>
    </section>);

};

export default TrustBuilding;